import { Card, Cell, DeprecatedIcon, Image, Text } from '@vinted/web-ui';
import useAbTest from 'hooks/useAbTest';
import useTranslate from 'hooks/useTranslate';
import { REFERRALS_URL } from 'constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IMAGE_URL = '/assets/referrals/gift-box.png';

const ReferralsBanner = _ref => {
  let {
    bottomSpacer
  } = _ref;
  const translate = useTranslate('profile.banners.referrals');
  const referralsVisibilityTest = useAbTest({
    abTestName: 'referrals_visibility',
    shouldTrackExpose: true
  });
  if ((referralsVisibilityTest === null || referralsVisibilityTest === void 0 ? void 0 : referralsVisibilityTest.variant) !== 'on') return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsx(Cell, {
        prefix: /*#__PURE__*/_jsx(Image, {
          src: IMAGE_URL,
          size: Image.Size.XLarge
        }),
        title: translate('title'),
        body: /*#__PURE__*/_jsx(Text, {
          text: translate('body')
        }),
        url: REFERRALS_URL,
        suffix: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "chevron-right",
          color: DeprecatedIcon.Color.GreyscaleLevel4,
          display: DeprecatedIcon.Display.Block
        })
      })
    }), bottomSpacer]
  });
};

export default ReferralsBanner;